import { render, staticRenderFns } from "./sub-underline-list.vue?vue&type=template&id=4a2b2897&scoped=true&"
import script from "./sub-underline-list.vue?vue&type=script&lang=js&"
export * from "./sub-underline-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b2897",
  null
  
)

export default component.exports